define([
	"dojo/_base/declare",
	"csi/core/ExtendedPath",
	"csi/core/Key",
	"csi/heading/_base",
	"csi/heading/Ref",
	"csi/xml"
], function(declare, ExtendedPath, Key, csiHeading, Ref, xml) {

	return declare(Ref, {
		/**
		 * @override
		 * Do not allow pasting to special items
		 */
		canPasteToCell(ctx, refNode) {
			return ctx.getNodeClass()?.isDerivedFrom("DSLineItem") && this.inherited(arguments);
		},

		getBaseHeading(/*Context*/ctx, /*Heading*/h) {
			// summary: return name heading if special item
			return ctx.__headingName || h;
		},

		getBaseRenderer(/*Context*/ctx, /*Heading*/h) {
			// summary: return name renderer if special item
			return ctx.__headingName ? csiHeading.getRenderer(xml.ATTR_STRING) : this;
		},

		isSpecial(ctx) {
			return xml.isValidURL(ctx.getNodeAttributeValue("Copy"));
		},

		reserveContext(/*Context*/ctx, /*Heading*/h) {
			// summary: render Node Name heading if item is unlinked
			if (this.isSpecial(ctx)) {
				var hName = ctx.view?.getHeading(new Key({
					extendedPath: ExtendedPath.create(ctx.getNodeType(), xml.path(h.m_id)),
					id: xml.ATTR_NAME,
				}));

				if (hName) {
					ctx.pushParams().setNodeURL(this._getValue(ctx, h));

					// force editability of Node Name to be same as Actual
					if (h.getRight()) {
						hName.setRight(h.getRight());
					}

					// save heading on context and set to use same CSS class - change cannot be temporary or else CSS will not be restored after editing
					if (hName.m_class && (hName.m_class != h.m_class)) {
						console.warn("DataSheetItemActual - CSS must be same for Actual and Name Headings");
					}

					hName.m_class = h.m_class;
					hName.m_link = null;
					ctx.__headingName = hName;
				}
			}

			this.inherited(arguments);
		},

		releaseContext(/*Context*/ctx, /*Heading*/h) {
			// summary: restore heading to original state
			if (ctx.__headingName) {
				ctx.__headingName = null;
				ctx.pop();
			}

			this.inherited(arguments);
		}
	});
});